import { render, staticRenderFns } from "./Unsuspension.vue?vue&type=template&id=12da968b&"
import script from "./Unsuspension.vue?vue&type=script&lang=js&"
export * from "./Unsuspension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports